// extracted by mini-css-extract-plugin
export var banner = "_24-0";